import { setQueryStringCachingBehavior } from "owa-querystring";
import { isGlobalFeatureEnabled } from "./isFeatureEnabled";

/**
 * Configure querystring caching based on feature flag.
 * Call this after feature flags are initialized.
 * Inverting dependency to avoid circular dependency with "isFeatureEnabled" in owa-querystring
 */
export default function configureQueryStringCaching(): void {
    setQueryStringCachingBehavior(isGlobalFeatureEnabled("fwk-removeQueryStringCache", true));
}
